import classnames from 'classnames';
import React from 'react';
import { FormGroup } from 'react-bootstrap';
import styles from './avatarNameDetail.module.scss';
import { Link } from 'react-router-dom';
import newTabIcon from 'v2/icons/new-tab.svg';

interface AvatarNameDetailProps {
  title: string;
  subtitle?: string;
  image: string;
  rounded?: boolean;
  newTab?: string;
}

const AvatarNameDetail = ({
  title,
  subtitle,
  image,
  rounded,
  newTab,
}: AvatarNameDetailProps) => {
  return (
    <div
      className={classnames('d-flex', {
        'align-items-start': subtitle,
        'align-items-center': !subtitle,
      })}
    >
      <img
        className={classnames('provider-logo mr-2', {
          'rounded-circle': rounded,
        })}
        src={image}
        alt="userImage"
      />
      <div>
        <FormGroup className="mb-0">
          <label className="m-0 text-primary-dark">{title}</label>
          {newTab && (
            <Link
              className={styles.popOut}
              role="link"
              target="_blank"
              to={newTab}
              data-cy={newTab}
            >
              <img src={newTabIcon} alt={'newTabIcon'}></img>
            </Link>
          )}
          {subtitle ? (
            <p className={classnames('text-light3 m-0', styles.subtitle)}>
              {subtitle}
            </p>
          ) : null}
        </FormGroup>
      </div>
    </div>
  );
};

export default AvatarNameDetail;
